var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAbbLightswitcherDark = function SvgAbbLightswitcherDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 80,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#abb_lightswitcher-dark_svg__a)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 26,
    cy: 46.398,
    fill: "#1F1F1F",
    rx: 24,
    ry: 6.932
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M25.139 8.687h1.714v8.794h-1.714z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#abb_lightswitcher-dark_svg__b)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFEE35",
    d: "m22.693 35.405.007-.091a3.32 3.32 0 0 1 1.253-2.35l4.703.083.14.126a3.17 3.17 0 0 1 1.065 2.246c.005.14.051.278.132.395l1.54 2.242c.533.775.82 1.684.829 2.614.024 2.768-2.295 5.024-5.164 5.024h-1.732c-2.856 0-5.17-2.233-5.17-4.988 0-.89.256-1.762.739-2.52l1.532-2.403a.8.8 0 0 0 .126-.378"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#abb_lightswitcher-dark_svg__c)",
    stroke: "#FF8122",
    d: "M26.645 50.008h-1.286c-4.343 0-7.833-3.396-7.833-7.55a7.06 7.06 0 0 1 .999-3.61l2.306-3.878c.151-.253.24-.538.26-.832l.016-.231a4.78 4.78 0 0 1 1.568-3.208l6.26-.54.122.118c.442.423.86 1.072 1.174 1.793s.503 1.47.523 2.077c.01.314.107.619.277.884l1.159 1.809 1.159 1.807a7.07 7.07 0 0 1 1.124 3.758c.034 4.173-3.465 7.603-7.828 7.603Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFAE0",
    d: "m20.593 34.105.015-.232a5.29 5.29 0 0 1 1.857-3.659l6.938-.597v.299c1.008.965 1.805 2.844 1.851 4.214.008.224.076.441.198.631l1.159 1.808 1.159 1.808a7.56 7.56 0 0 1 1.203 4.024c.036 4.467-3.703 8.107-8.328 8.107H25.36c-4.602 0-8.333-3.604-8.333-8.05 0-1.357.369-2.69 1.069-3.867l2.307-3.877c.11-.186.176-.395.19-.61"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.71 41.885c.028-.066-.012-.14-.089-.163-.077-.024-.162.01-.19.076zm3.683-6.298c-.027.484-.3 1.686-.635 2.901-.334 1.215-.72 2.417-.966 2.902l.272.102c.259-.51.65-1.734.984-2.945.332-1.211.613-2.436.643-2.948zm-1.601 5.803c-.375.737-1.032 1.067-1.517 1.101-.245.018-.426-.04-.524-.133-.092-.088-.14-.238-.04-.473l-.28-.087c-.124.294-.087.552.099.73.18.172.467.239.77.218.608-.044 1.353-.443 1.764-1.254z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M25.56 36.78c-.023.967.346 4.791-.065 5.708-.34.76-.978.878-1.042.468.078-.112.141-.1.277 0 .17.123 0 .214-.085.39M26.44 36.78c.022.967-.347 4.791.064 5.708.34.76.978.878 1.042.468-.078-.112-.141-.1-.277 0-.17.123 0 .214.085.39"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M30.29 41.885c-.029-.066.011-.14.088-.163.078-.024.163.01.19.076zm-3.684-6.298c.028.484.301 1.686.635 2.901s.721 2.417.967 2.902l-.272.102c-.259-.51-.651-1.734-.984-2.945s-.614-2.436-.643-2.948zm1.602 5.803c.374.737 1.032 1.067 1.517 1.101.244.018.426-.04.524-.133.091-.088.14-.238.04-.473l.28-.087c.124.294.087.552-.099.73-.18.172-.468.239-.77.218-.609-.044-1.353-.443-1.764-1.254z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "abb_lightswitcher-dark_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.306 30.215h7.388c.181 0 .328-.134.328-.299s-.147-.298-.328-.298h-7.389c-.18 0-.328.133-.328.298s.147.299.328.299"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "M22.306 30.215h7.388c.181 0 .328-.134.328-.299s-.147-.298-.328-.298h-7.389c-.18 0-.328.133-.328.298s.147.299.328.299"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "M29.694 30.215v-1h-7.389v2h7.389zm-7.389 0v-1c.28 0 .672.226.672.701h-2c0 .805.687 1.299 1.328 1.299zm-.328-.299h1a.687.687 0 0 1-.672.702v-2c-.641 0-1.328.493-1.328 1.298zm.328-.298v1h7.389v-2h-7.389zm7.389 0v1a.687.687 0 0 1-.672-.702h2c0-.805-.687-1.298-1.328-1.298zm.328.298h-1c0-.475.393-.701.672-.701v2c.641 0 1.328-.494 1.328-1.299z",
    mask: "url(#abb_lightswitcher-dark_svg__d)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "abb_lightswitcher-dark_svg__e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.596 30.215h7.426v-.597h-7.426z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "M22.596 30.215h7.426v-.597h-7.426z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "M30.022 30.215v1h1v-1zm-7.426 0h-1v1h1zm0-.597v-1h-1v1zm7.426 0h1v-1h-1zm0 .597v-1h-7.426v2h7.426zm-7.426 0h1v-.597h-2v.597zm0-.597v1h7.426v-2h-7.426zm7.426 0h-1v.597h2v-.597z",
    mask: "url(#abb_lightswitcher-dark_svg__e)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "abb_lightswitcher-dark_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.596 29.02h7.426v-.596h-7.426z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "M22.596 29.02h7.426v-.596h-7.426z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "M30.022 29.02v1h1v-1zm-7.426 0h-1v1h1zm0-.596v-1h-1v1zm7.426 0h1v-1h-1zm0 .597v-1h-7.426v2h7.426zm-7.426 0h1v-.597h-2v.597zm0-.597v1h7.426v-2h-7.426zm7.426 0h-1v.597h2v-.597z",
    mask: "url(#abb_lightswitcher-dark_svg__f)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "abb_lightswitcher-dark_svg__g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.977 27.827h8.045v-.597h-8.045z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "M21.977 27.827h8.045v-.597h-8.045z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "M30.022 27.827v1h1v-1zm-8.045 0h-1v1h1zm0-.597v-1h-1v1zm8.045 0h1v-1h-1zm0 .597v-1h-8.045v2h8.045zm-8.045 0h1v-.597h-2v.597zm0-.597v1h8.045v-2h-8.045zm8.045 0h-1v.597h2v-.597z",
    mask: "url(#abb_lightswitcher-dark_svg__g)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "abb_lightswitcher-dark_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.596 26.633h7.426v-.597h-7.426z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "M22.596 26.633h7.426v-.597h-7.426z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "M30.022 26.633v1h1v-1zm-7.426 0h-1v1h1zm0-.597v-1h-1v1zm7.426 0h1v-1h-1zm0 .597v-1h-7.426v2h7.426zm-7.426 0h1v-.597h-2v.597zm0-.597v1h7.426v-2h-7.426zm7.426 0h-1v.597h2v-.597z",
    mask: "url(#abb_lightswitcher-dark_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    stroke: "#1F1F1F",
    d: "M22.736 24.94a.9.9 0 0 1 .567-.194h5.393c.234 0 .426.078.567.194zM21.891 29.118l-.004-.004a.14.14 0 0 1-.029-.093c0-.048.017-.08.03-.094l.002-.003h8.219l.003.003c.012.014.03.046.03.094a.14.14 0 0 1-.034.097z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "abb_lightswitcher-dark_svg__i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.903 28.424h8.194c.3 0 .544-.133.544-.298s-.244-.299-.544-.299h-8.194c-.3 0-.545.134-.545.299s.244.298.545.298"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "M21.903 28.424h8.194c.3 0 .544-.133.544-.298s-.244-.299-.544-.299h-8.194c-.3 0-.545.134-.545.299s.244.298.545.298"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "M30.097 28.424v-1h-8.194v2h8.194zm-8.194 0v-1c-.015 0 .02-.005.096.036.038.02.36.213.36.666h-2c0 .617.443.959.678 1.088.273.149.58.21.866.21zm-.545-.298h1a.75.75 0 0 1-.36.666c-.075.04-.11.035-.095.035v-2c-.285 0-.593.062-.866.21-.235.13-.679.471-.679 1.089zm.545-.299v1h8.194v-2h-8.194zm8.194 0v1c.015 0-.02.006-.096-.035a.75.75 0 0 1-.36-.666h2c0-.618-.443-.96-.679-1.088-.272-.15-.58-.21-.865-.21zm.544.299h-1c0-.453.322-.645.36-.666.075-.041.11-.036.096-.036v2c.285 0 .593-.061.865-.21.236-.13.68-.47.68-1.088z",
    mask: "url(#abb_lightswitcher-dark_svg__i)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "abb_lightswitcher-dark_svg__j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.88 27.23h8.24c.288 0 .521-.134.521-.298 0-.165-.233-.299-.52-.299h-8.242c-.287 0-.52.134-.52.299s.233.298.52.298"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "M21.88 27.23h8.24c.288 0 .521-.134.521-.298 0-.165-.233-.299-.52-.299h-8.242c-.287 0-.52.134-.52.299s.233.298.52.298"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "M30.12 27.23v-1h-8.24v2h8.24zm-8.24 0v-1q.006-.001.032.005c.016.004.05.014.096.04.055.032.35.227.35.657h-2c0 .595.412.939.656 1.078.271.156.58.22.865.22zm-.522-.298h1c0 .43-.295.625-.35.656a.4.4 0 0 1-.096.04l-.033.005v-2c-.286 0-.594.065-.865.22-.244.14-.656.484-.656 1.079zm.521-.299v1h8.241v-2h-8.24zm8.241 0v1q-.006.001-.032-.004a.4.4 0 0 1-.096-.04.75.75 0 0 1-.35-.657h2c0-.595-.413-.94-.656-1.08a1.75 1.75 0 0 0-.866-.219zm.521.299h-1c0-.43.296-.625.35-.657a.4.4 0 0 1 .097-.04l.032-.005v2c.286 0 .595-.064.866-.22.243-.139.655-.483.655-1.078z",
    mask: "url(#abb_lightswitcher-dark_svg__j)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    stroke: "#1F1F1F",
    d: "m21.891 26.133-.004-.004a.14.14 0 0 1-.029-.093c0-.047.017-.08.03-.093q.001-.002.002-.003h8.219l.003.003c.012.014.03.046.03.093a.14.14 0 0 1-.034.097z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "M29.403 29.618 27.547 32.9l-.62 1.79-.345 2.465c-.042.284-1.015.3-1.11.019l-.029-.083-.297-2.665a3.5 3.5 0 0 0-.519-1.448l-2.031-3.317 5.999-.028"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#abb_lightswitcher-dark_svg__k)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.944 40.934c-2.462 0-4.458.903-4.458 2.016 0 1.114 1.996 2.017 4.458 2.017s4.458-.903 4.458-2.017-1.996-2.016-4.458-2.016"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#abb_lightswitcher-dark_svg__l)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 16,
    d: "M29.606 42.989c-1.21-.17-2.09.211-2.368.326-.266-.076-.892-.422-1.354-.422s-.822.365-.995.442c-.093-.032-.454-.323-.756-.385-.303-.06-1.334-.025-1.811 0"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#abb_lightswitcher-dark_svg__m)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 8,
    d: "M29.606 42.989c-1.21-.17-2.09.211-2.368.326-.266-.076-.892-.422-1.354-.422s-.822.365-.995.442c-.093-.032-.454-.323-.756-.385-.303-.06-1.334-.025-1.811 0"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#abb_lightswitcher-dark_svg__n)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 5,
    d: "M29.606 42.989c-1.21-.17-2.09.211-2.368.326-.266-.076-.892-.422-1.354-.422s-.822.365-.995.442c-.093-.032-.454-.323-.756-.385-.303-.06-1.334-.025-1.811 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    fillRule: "evenodd",
    d: "M2 45.983c3.027-3.007 12.564-5.202 23.86-5.202 11.672 0 21.465 2.344 24.14 5.505-1.068-17.405-11.41-31.061-24.01-31.061-12.527 0-22.822 13.498-23.99 30.758",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "M25.139 0h1.714v8.687h-1.714z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "abb_lightswitcher-dark_svg__b",
    width: 90.066,
    height: 90.731,
    x: -18.704,
    y: -6.036,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2201_27756",
    stdDeviation: 19.5
  })), /*#__PURE__*/React.createElement("filter", {
    id: "abb_lightswitcher-dark_svg__k",
    width: 115.317,
    height: 110.433,
    x: -31.714,
    y: -12.266,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2201_27756",
    stdDeviation: 26.6
  })), /*#__PURE__*/React.createElement("filter", {
    id: "abb_lightswitcher-dark_svg__l",
    width: 102.311,
    height: 109.032,
    x: -25.598,
    y: -11.107,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2201_27756",
    stdDeviation: 23
  })), /*#__PURE__*/React.createElement("filter", {
    id: "abb_lightswitcher-dark_svg__m",
    width: 27.252,
    height: 27.937,
    x: 12.507,
    y: 29.293,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2201_27756",
    stdDeviation: 4.8
  })), /*#__PURE__*/React.createElement("filter", {
    id: "abb_lightswitcher-dark_svg__n",
    width: 43.164,
    height: 41.026,
    x: 4.488,
    y: 22.693,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2201_27756",
    stdDeviation: 8.85
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "abb_lightswitcher-dark_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-.49266 -16.46773 14.61476 -.43723 26.032 40.361)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3D00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "abb_lightswitcher-dark_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2 8.687h48v46H2z"
  })))));
};
export default SvgAbbLightswitcherDark;